var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { TactonResponseStatus, } from "./types";
import { componentListGroupName, componentSelectionGroupName, outputGroupName, calculationInputGroupName, adminGroupName, systemTemplateGroupName, systemTemplateSelectedFieldName, } from "./constants";
import { getImageUrl } from "./common-api";
import { getParameter } from "./parameter-transforms";
import { getComponents, getSelections } from "./component-transforms";
import { getCalculationInput, getOutput, getReleaseNotes, } from "./group-transforms";
import { getEmptySystemData } from "api/utility/system-data";
import { SpecialGroupLayout, } from "api/types";
export { getReleaseNotes } from "./group-transforms";
export var errors;
(function (errors) {
    errors["STEP_NOT_FOUND"] = "unexpected format, step not found";
    errors["NO_ROOT_GROUP"] = "unexpected format, no rootGroup found";
    errors["ROOT_GROUP_HAS_FIELD"] = "unexpected format, rootGroup has field";
})(errors || (errors = {}));
var processAdminGroup = function (group, systemData, ticket) {
    var releaseNotes = getReleaseNotes(group);
    if (releaseNotes) {
        systemData.releaseNotes = releaseNotes;
    }
    var templateGroup = group.members.find(function (member) { return member.name === systemTemplateGroupName; });
    var templateField = group.members.find(function (member) { return member.name === systemTemplateSelectedFieldName; });
    if (!templateGroup || !templateField)
        return;
    systemData.parameters[templateField.name] = getParameter(templateField, group.name, ticket);
    systemData.templateSystemGroups = templateGroup.members.map(function (tg) { return ({
        description: tg.description,
        members: tg.members.map(function (template) { return ({
            name: template.name,
            value: template.value,
            description: template.description,
            image: template.properties.tc_field_view_picture &&
                getImageUrl(template.properties.tc_field_view_picture, ticket),
        }); }),
    }); });
    systemData.templateCode = templateField.properties.code;
};
var processParameterGroup = function (group, systemData, hiddenParameters, ticket) {
    var e_1, _a, e_2, _b;
    var _c, _d, _e, _f;
    var isGroupHidden = ((_c = group.properties) === null || _c === void 0 ? void 0 : _c.hidden) === "yes";
    var isGroupHiddenInWizard = ((_d = group.properties) === null || _d === void 0 ? void 0 : _d.wizard_hidden) === "yes";
    var groupSpecialLayout = ((_f = (_e = group.properties) === null || _e === void 0 ? void 0 : _e.group_renderer) !== null && _f !== void 0 ? _f : SpecialGroupLayout.DEFAULT);
    var members = group.members;
    try {
        for (var members_1 = __values(members), members_1_1 = members_1.next(); !members_1_1.done; members_1_1 = members_1.next()) {
            var member = members_1_1.value;
            if (member.isGroup) {
                var properties = member.properties;
                var subGroup = __assign({ id: member.name, memberIds: member.members.map(function (field) { return field.name; }) }, (properties
                    ? {
                        properties: {
                            fieldSeparator: properties.field_separator,
                            groupImage: properties.tc_group_picture &&
                                getImageUrl(properties.tc_group_picture, ticket),
                        },
                    }
                    : {}));
                systemData.parameterSubGroups.push(subGroup);
            }
            var params = member.isGroup ? member.members : [member];
            try {
                for (var params_1 = (e_2 = void 0, __values(params)), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                    var param = params_1_1.value;
                    if (!param.isParameter)
                        continue;
                    var field = param;
                    var parameter = getParameter(field, group.name, ticket);
                    var isParameterHidden = member.properties && member.properties.hidden === "yes";
                    if (isParameterHidden || isGroupHidden) {
                        hiddenParameters[field.name] = parameter;
                    }
                    else {
                        systemData.parameters[field.name] = parameter;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (params_1_1 && !params_1_1.done && (_b = params_1.return)) _b.call(params_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (members_1_1 && !members_1_1.done && (_a = members_1.return)) _a.call(members_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (!isGroupHidden) {
        systemData.parameterGroups[group.name] = {
            id: group.name,
            title: group.description || "",
            hiddenInWizard: isGroupHiddenInWizard,
            specialGroupLayout: groupSpecialLayout,
        };
    }
};
export var deserializeSystemDataParameters = function (response, ticket) {
    var e_3, _a;
    var _b;
    var step = response.steps.find(function (step) { return step.current; });
    if (!step) {
        throw Error(errors.STEP_NOT_FOUND);
    }
    var activeStep = step;
    var groups = activeStep.rootGroup.members;
    var systemData = __assign(__assign({}, getEmptySystemData()), { isCurrentStep: step.current });
    var componentListGroup;
    var hiddenParameters = {};
    try {
        for (var groups_1 = __values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
            var group = groups_1_1.value;
            if (!group.isGroup)
                continue;
            switch (group.name) {
                case componentListGroupName:
                    componentListGroup = group;
                    break;
                case componentSelectionGroupName:
                    Object.assign(systemData, getSelections(group));
                    break;
                case outputGroupName:
                    systemData.output = getOutput(group);
                    break;
                case calculationInputGroupName:
                    systemData.calculationInput = getCalculationInput(groups, group);
                    break;
                case adminGroupName:
                    processAdminGroup(group, systemData, ticket);
                    break;
                default:
                    processParameterGroup(group, systemData, hiddenParameters, ticket);
                    break;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (groups_1_1 && !groups_1_1.done && (_a = groups_1.return)) _a.call(groups_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var isObjectSurfaceOily = ((_b = systemData.parameters.oily_object_field) === null || _b === void 0 ? void 0 : _b.value) === "Yes";
    var componentLists = componentListGroup &&
        getComponents(componentListGroup, isObjectSurfaceOily);
    if (componentLists)
        Object.assign(systemData, componentLists);
    if (response.response.status === TactonResponseStatus.RESOLVABLE) {
        var conflictResponse = response.response;
        if (!systemData.parameters[conflictResponse.parameter])
            return systemData;
        var proposedChanges = conflictResponse.changed
            .map(function (change) {
            var changeParameter = systemData.parameters[change.name] || hiddenParameters[change.name];
            if (!changeParameter)
                return null;
            return {
                oldParameter: __assign(__assign({}, changeParameter), { value: change.oldValue }),
                newParameter: __assign(__assign({}, changeParameter), { value: change.newValue }),
            };
        })
            .filter(function (c) { return c !== null; });
        systemData.conflict = {
            conflictingParameter: __assign(__assign({}, systemData.parameters[conflictResponse.parameter]), { value: conflictResponse.value }),
            proposedChanges: proposedChanges,
        };
    }
    return systemData;
};
